const buildQuery = (params) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  return q.toString() ? `?${q.toString()}` : '';
};

export default {
  GET_AUDIT_TRAIL: ({ page = 1, rowsPerPage = 10, model, actorId, action, startDate, endDate }) =>
    `audits/trail/${buildQuery({
      page,
      page_size: rowsPerPage, // eslint-disable-line camelcase
      model,
      actor_id: actorId, // eslint-disable-line camelcase
      action,
      start_date: startDate, // eslint-disable-line camelcase
      end_date: endDate, // eslint-disable-line camelcase
    })}`,

  EXPORT_AUDIT_TRAIL: ({ model, actorId, action, startDate, endDate } = {}) =>
    `audits/trail/export/${buildQuery({
      model,
      actor_id: actorId, // eslint-disable-line camelcase
      action,
      start_date: startDate, // eslint-disable-line camelcase
      end_date: endDate, // eslint-disable-line camelcase
    })}`,
};
